import { useMemo } from 'react';
import { useSubsidiaries } from './use-subsidiaries';

type SubsidiaryNameMap = {
  subsidiaryNameById: Record<string, string>;
  defaultSubsidiary: string | undefined;
};

export function useSubsidiaryNameMap(): SubsidiaryNameMap {
  const { data } = useSubsidiaries();

  return useMemo(() => {
    const subsidiaries = data?.subsidiaries ?? [];
    const subsidiaryNameById: Record<string, string> = Object.fromEntries(
      subsidiaries.map((subsidiary) => [subsidiary.id, subsidiary.name]),
    );
    const defaultSubsidiary = subsidiaries.find((subsidiary) => subsidiary.isPrimary)?.name;
    return { subsidiaryNameById, defaultSubsidiary };
  }, [data]);
}
